import React, { Component } from "react";
import HrMiddleWare from "../../middleWare/HrMiddleWare";
import http from "../../middleWare/httpMiddleWare";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ConsolidatePDF from "../PDF/ConsolidatePDF";
import IDPPDF from "../PDF/IDPConsolidatePDF";
import html2canvas from "html2canvas";
import MappingMiddleware from "../../middleWare/MappingMiddleware";
import * as jsPDF from "jspdf";
import queryString from "query-string";
import { ACCESS_POINT } from "../../config";
import image from "./images.jpeg";
import { SingleSelect } from "../../components/Form";
import DatePicker from "../../components/Form/DatePicker";
import { Datatable } from "../../components/Datatable";
import PreLoader from "./preloader";
import ManageIDP1 from '../User/Addidppage'
import moment from "moment";
import customFont from "../ttf_files/Montserrat-SemiBold_72e0d276db1e5baa6f2b4caddfef5b93.ttf"
import ptsans from "../ttf_files/pt-sans.narrow.ttf"
import "./HrStyles.css"
import {
  Image,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font
} from "@react-pdf/renderer";
import { object } from "prop-types";
class ConsolidateReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datas: [],
      derail: [],
      showdownload: false,
      userid: queryString.parse(this.props.location.search).id,
      pdfyearId: localStorage.getItem("yearId"),
      groupcompId: localStorage.getItem("groupcompId"),
      idpTable: [],
      SkillsData: [],
      SkillsData2: [],
      SkillsData1: [],
      ShortContentData: [],
      MidContentData: [],
      LongContentData: []
    };
  }
  async componentDidMount() {
    let adminId = await localStorage.getItem("adminId");
    let JobId = localStorage.getItem("jobRoleId")

    //  console.log(adminId)
    let userId = null;
    if (this.state.userid) {
      userId = this.state.userId;
    } else {
      userId = await localStorage.getItem("userId");
    }
    this.setState({ userId });
    console.log(userId);
    // const CreateDownloadPDF = await HrMiddleWare.CreateDownloadPDF(userId);
    // const result = await HrMiddleWare.getUserDetails(userId);
    const result = await HrMiddleWare.getUserDetailsyearbased(userId, JobId);

    console.log(result,"result");
    console.log(userId);
    let userDetails;

    let userDetailsPromote = await HrMiddleWare.getRandomData(
      "tbl_promotion,tbl_users",
      `tbl_promotion.userid = ${userId} and tbl_users.id = ${userId} and tbl_promotion.jobRole=${JobId}`,
      "tbl_promotion.*,tbl_users.mobile_no,tbl_users.email_id,tbl_users.qualification,tbl_users.age,tbl_users.telphone,tbl_users.location,tbl_users.name,tbl_users.image,tbl_users.address"
    );
    // console.log(userDetailsPromote,"userDetailsPromote");

    let userDetailUnPromote = await HrMiddleWare.getRandomData(
      "tbl_users",
      `id = ${userId}`,
      "*"
    );
    if (userDetailsPromote && userDetailsPromote.data && userDetailsPromote.data.length) {
      userDetails = userDetailsPromote
    } else {
      userDetails = userDetailUnPromote
    }

    // console.log(userDetails,"userDetails");
    let yearList = await MappingMiddleware.getYear();
    if (yearList) {
      this.setState({ yearList: yearList.data });
    }

    this.state = { imageview: "", username: "" };

    await this.setState({
      imageview: userDetails.data[0].image,
      username: userDetails.data[0].name
    });
    let grcom = await HrMiddleWare.getRandomData(`tbl_gcompanies`, `tbl_gcompanies.id=${this.state.groupcompId}`, "*");

    if (grcom) {
      // var logosrc=ACCESS_POINT +"/getpro/getprofile?fileurl=" + grcom.data[0].image;

      this.setState({ groupcompany_details: grcom.data });
    }
    //and Tblderailers_map.derailersid and tbl_derailers.id and tbl_derailers.customerId = ${adminId} and tbl_derailers.adminId = ${adminId}
    let derailers = await HrMiddleWare.getRandomData(
      "Tblderailers_map,tbl_derailers",
      `Tblderailers_map.worklevelid = ${userDetails.data[0].worklevel} and Tblderailers_map.jobroleid = ${userDetails.data[0].jobRole} and  Tblderailers_map.customerId = ${adminId} and tbl_derailers.id=Tblderailers_map.derailersid`,
      "*"
    );

    let derail = [];

    derailers.data.map((item, i) => {
      derail.push(
        <div>
          <td>derail{item.derailers}</td>
        </div>
      );
    });
    this.setState({ derail: derail });
    let wrk = userDetails.data[0].worklevel;
    let worklevel = await HrMiddleWare.getRandomData(
      "tbl_worklevel",
      `id = ${wrk} and customerid = ${adminId} and adminId = ${adminId}`,
      "*"
    );
    let jobdescription = await HrMiddleWare.getRandomData(
      "tbl_jobdescription",
      `jobRole = ${userDetails.data[0].jobRole} and
       department = ${userDetails.data[0].department} and
       customerid = ${adminId} and status ='active'`,
      "*"
    );
    //  console.log(jobdescription.data[0].jobdescription);
    if (jobdescription.data.length) {
      this.setState({ jobdescription: jobdescription.data[0].jobdescription })
    }
    else {
      this.setState({ jobdescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus scelerisque vitae felis in malesuada. Nulla viverra odio vitae condimentum iaculis. Sed at egestas erat, eu maximus nibh. Pellentesque non lobortis augue, in tincidunt enim. Sed imperdiet, justo non maximus feugiat, arcu elit vestibulum purus, vel semper turpis sem a velit. Quisque vitae lobortis erat. Quisque in quam eu dolor sollicitudin viverra. Nulla sit amet felis vitae neque mollis tempus. Mauris quis velit nec diam finibus porttitor. Suspendisse luctus interdum maximus. Sed rutrum imperdiet feugiat. Pellentesque dictum elit sed quam posuere bibendum. Curabitur porta volutpat sapien, sit amet vulputate lacus gravida ac.' })
    }
    // this.setState({ jobdescription: jobdescription.data[0].jobdescription });
    let designation = await HrMiddleWare.getRandomData(
      "tbl_designation",
      `id = ${userDetails.data[0].designation}`,
      "*"
    );
    let jobRole = await HrMiddleWare.getRandomData(
      "tbl_jobRole",
      `id = ${userDetails.data[0].jobRole} and customerid = ${adminId} and adminId = ${adminId} `,
      "*"
    );
    let beh = await HrMiddleWare.getRandomData(
      "tbl_theme",
      `customerid=${adminId} and textType='Behavioral'`,
      "theme as label,id as value"
    );
    let tech = await HrMiddleWare.getRandomData(
      "tbl_theme",
      `customerid=${adminId} and textType='Technical'`,
      "theme as label,id as value"
    );
    let TECHcriticals = await HrMiddleWare.getRandomData(
      "tbl_tech_comp_criticals",
      `cmpid=${adminId} and status = 'active'`,
      "*"
    );

    let pdfIdp = await HrMiddleWare.getRandomData(
      "tbl_idp_goalterm",
      // `userid=${userDetails.data[0].id} and yearid=${this.state.pdfyearId} and customerid=${adminId}`,
      `userid=${userDetails.data[0].id} and yearid=${this.state.pdfyearId} `,

      "*"
    );
    let name = userDetails.data[0].name;
    let workLvl = worklevel.data[0].worklevel;
    let designationName = designation.data[0].designation;
    let jobRoleName = jobRole.data[0].jobRoleName;

    let tc = [];
    let bc = [];
    if (result.data) {
      // console.log(result.data);
      // result.data[0].map((i, key) => {
      if (result.data[0].userBehIndicators) {
        result.data[0].userBehIndicators.map((a1, id1) => {
          let ind1 = [];
          if (a1.indicators) {
            a1.indicators.map((a2, id2) => {
              if (a2.indicators) {
                ind1.push(
                  <tr style={{ border: "0" }}>
                    {" "}
                    {a2.indicators}
                    <br />{" "}
                  </tr>
                );
              } else {
                ind1.push("No Indicators");
              }
            });
          }
          bc.push(
            <div>
              <table
                width="100%"
                style={{ borderCollapse: "inherit", paddingLeft: "20px" }}
              >
                <tbody>
                  <tr style={{ border: "0" }}>
                    <td className="px-2" style={{ width: "20%" }}>
                      <b class="tab-tex-content">Theme</b>
                    </td>
                    <td className="px-2" style={{ width: "80%" }}>
                      <b style={{ fontSize: "18px" }}>{a1.theme}</b>
                    </td>
                  </tr>
                  <tr style={{ border: "0" }}>
                    <td className="px-2" >
                      <b class="tab-tex-content ">Competency Name</b>
                    </td>
                    <td className="px-2">
                      <p style={{ fontSize: "14px" }}>{a1.competencyname}</p>
                    </td>
                  </tr>
                  <tr style={{ border: "0" }}>
                    <td className="px-2">
                      <b class="tab-tex-content ">Competency Definition</b>
                    </td>
                    <td className="px-2">{a1.compDescription}</td>
                  </tr>
                  <tr style={{ border: "0" }}>
                    <td className="px-2">
                      <b class="tab-tex-content ">Indicators</b>
                    </td>
                    <td className="px-2">
                      <table
                        width="100%"
                        style={{
                          borderCollapse: "inherit",
                          margin: "-20px",
                          padding: "20px"
                        }}
                      >
                        <tbody>
                          <tr style={{ border: "0" }}>
                            <td className="px-2">
                              <b class="tab-tex-content ">Indicator</b>
                            </td>
                          </tr>
                          <tr style={{ border: "0" }}>{ind1}</tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <hr />
            </div>
          );
        });
      }
      if (result.data[0].userTechIndicators) {
        result.data[0].userTechIndicators.map((item, i) => {
          if (TECHcriticals) {
            var critici = TECHcriticals.data.filter((ival, i) => {
              return (
                item.theme == ival.theme && item.competencyid == ival.competency
              );
            });
          }
          let compDescription = [];
          if (item.compDescription) {
            compDescription.push(item.compDescription);
          } else {
            compDescription.push("No Competency Definition");
          }
          let compImportant = [];
          if (item.compImportant) {
            compImportant.push(item.compImportant);
          } else {
            compImportant.push("No Competency Important");
          }
          let b1 = [];
          let b2 = [];
          if (critici.length > 0) {
            critici.map((b1, id) => {
              b1.push(
                <tr style={{ border: "0" }}>
                  <td>
                    <b class="red">Critical Knowledge Area</b>
                  </td>
                  <td>{b1.critical_knowledge}</td>
                </tr>
              );
              b2.push(
                <tr style={{ border: "0" }}>
                  <td>
                    <b class="red"> Performance Parameter</b>
                  </td>
                  <td>{item.critical_performance}</td>
                </tr>
              );
            });
          } else {
            b1.push(
              <tr style={{ border: "0" }}>
                <td>
                  <b class="red">Critical Knowledge Area</b>
                </td>
                <td>No Critical Knowledge Area</td>
              </tr>
            );
            b2.push(
              <tr style={{ border: "0" }}>
                <td>
                  <b class="red"> Performance Parameter</b>
                </td>
                <td>No Performance Parameter</td>
              </tr>
            );
          }
          let ind2 = [];
          if (item.indicators) {
            item.indicators.map((jval, j) => {
              if (jval.indicators) {
                ind2.push(
                  <tr style={{ border: "0" }}>
                    {jval.indicators}
                    <br />
                  </tr>
                );
              } else {
                ind2.push("No Indicators");
              }
            });
          }

          tc.push(
            <div>
              <table
                width="100%"
                style={{ borderCollapse: "inherit", paddingLeft: "20px" }}
              >
                <tbody>
                  <tr style={{ border: "0" }}>
                    <td style={{ width: "20%" }}>
                      <b class="red">Theme</b>
                    </td>
                    <td style={{ width: "80%" }}>
                      <b style={{ fontSize: "18px" }}>{item.theme}</b>
                    </td>
                  </tr>
                  <tr style={{ border: "0" }}>
                    <td>
                      <b class="red">Competency Name</b>
                    </td>
                    <td>
                      <p style={{ fontSize: "14px" }}>{item.competencyname}</p>
                    </td>
                  </tr>
                  <tr style={{ border: "0" }}>
                    <td>
                      <b class="red">Competency Definition</b>
                    </td>
                    <td>{compDescription}</td>
                  </tr>
                  <tr style={{ border: "0" }}>
                    <td>
                      <b class="red">Why it's important</b>
                    </td>
                    <td>{compImportant}</td>
                  </tr>
                  {b1}
                  {b2}
                  <tr style={{ border: "0" }}>
                    <td>
                      <b class="red">Indicators</b>
                    </td>
                    <td>
                      <table
                        width="100%"
                        style={{
                          borderCollapse: "inherit",
                          margin: "-20px",
                          padding: "20px"
                        }}
                      >
                        <tbody>
                          <tr style={{ border: "0" }}>
                            <td>
                              <b class="red">Indicator</b>
                            </td>
                          </tr>
                          <tr style={{ border: "0" }}>{ind2}</tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <hr />
            </div>
          );
        });
      }
      // });
    }
    // console.log(result.data);
    this.setState({
      userId,
      tc,
      bc,
      user: result.data,
      data: userDetails.data[0],
      name,
      workLvl,
      designationName,
      jobRoleName,
      derailers: derailers.data,
      yearList: yearList.data,
      pdfIdp: pdfIdp.data
    });
  }

  viewfun = async () => {
    let { data } = this.state;
    let year = localStorage.getItem("yearId");
    console.log(this.state.user)
    // consolse.log(`http://localhost/mdc/competency-reactjs/src/php/examples/example_048.php?userid=${data.id}&companyid=${data.customerid}&yearid=${year}`)
    window.location.href = `http://localhost/competancy/competency-reactjs/src/php/examples/example_048.php?userid=${data.id}&companyid=${data.customerid}&yearid=${year}`;
    //  window.open(`http://${ACCESS_POINT}/hr/DownloadPdf1/${this.state.user[0].name}`,'_blank');

  };

  idp = async e => {
    console.log(this.state.userId, e.value);
    try {
      let result = await HrMiddleWare.getRandomData(
        "idp_goals",
        `createdById=${this.state.userId} and yearId=${e.value}`,
        "*"
      );
      console.log(result.data);
      if (result.data) {
        this.setState({ idpYear: e, idpTable: result.data, show: true });
      }

    } catch (error) {
      console.log(error);
    }
    this.financialYearSelect(e)
  };
  financialYearSelect = async e => {
    const { userId } = this.state;
    this.setState({ financialYearSelected: e });
    let IDP_Data = await HrMiddleWare.getRandomData(
      "tbl_idp_goalterm",
      `userid = ${userId} and yearid = ${e.value} `,
      "*"
    );
    // console.log(IDP_Data);
    if (IDP_Data) {
      let ShortContentData = [];
      let MidContentData = [];
      let LongContentData = [];
      IDP_Data.data.map((ival, i) => {
        if (ival.termtype == "short") {
          ival.collapse = false;
          ival.startdate = moment(ival.startdate).format("YYYY-MM-DD");
          ival.enddate = moment(ival.enddate).format("YYYY-MM-DD");
          ival.actual_end_date = ival.actual_end_date ? moment(ival.actual_end_date).format("YYYY-MM-DD") : "-";
          ShortContentData.push(ival);
        } else if (ival.termtype == "mid") {
          ival.collapse = false;
          ival.startdate = moment(ival.startdate).format("YYYY-MM-DD");
          ival.enddate = moment(ival.enddate).format("YYYY-MM-DD");
          ival.actual_end_date = ival.actual_end_date ? moment(ival.actual_end_date).format("YYYY-MM-DD") : "-";
          MidContentData.push(ival);
        } else if (ival.termtype == "long") {
          ival.collapse = false;
          ival.startdate = moment(ival.startdate).format("YYYY-MM-DD");
          ival.enddate = moment(ival.enddate).format("YYYY-MM-DD");
          ival.actual_end_date = ival.actual_end_date ? moment(ival.actual_end_date).format("YYYY-MM-DD") : "-";
          LongContentData.push(ival);
        }
      })
      this.setState({ ShortContentData, MidContentData, LongContentData })
      console.log("Short mid long", ShortContentData, MidContentData, LongContentData);
      this.manageIDP(null, e.value);
    }

  }

  manageIDP = async (a = null, b = null) => {
    const { userId, behTechSelected, financialYearSelect } = this.state;

    if (b != null) {

      let ManageIDP = await HrMiddleWare.getRandomData(
        "tbl_idp_goals",
        `userid = ${userId} and yearId = ${b}
    
       `,
        '*'
      )
      console.log(ManageIDP);
      let SkillsData = [];
      let SkillsData1 = [];
      let SkillsData2 = [];
      if (ManageIDP.data.length && ManageIDP != undefined) {
        let result = ManageIDP.data[0];
        //  this.setState({ManageIDP:ManageIDP.data,PDf_Data:ManageIDP.data});
        console.log(ManageIDP)

        SkillsData = JSON.parse(result.Skills);
        SkillsData1 = JSON.parse(result.Skills_2);
        SkillsData2 = JSON.parse(result.resources_required);

        this.setState({ SkillsData, SkillsData2, SkillsData1, showdownload: true });

      } else {
        //  this.setState({ManageIDP:[{data:null}],PDf_Data:[]});

        this.setState({ showdownload: true })
      }



    }
  }

  column = [
    {
      Header: "IDP type",
      accessor: "type"
      // Cell: d => (d.original.type === 1 ? "Behavioral" : "Technaical")
    },
    {
      Header: "Goal",
      accessor: "goalsname"
      // Cell: d => this.otherEdits(d, d.original.goalsname, "goalsname")
    },
    {
      Header: "Criteria",
      accessor: "Criteria_Completion"
      // Cell: d =>
      //   this.otherEdits(
      //     d,
      //     d.original.Criteria_Completion,
      //     "Criteria_Completion"
      //   )
    },
    {
      Header: "Date",
      accessor: "date",
      Cell: d => this.date(d)
    },
    {
      Header: "Progress",
      accessor: "percentage"
      // Cell: d => this.otherEdits(d, d.original.percentage, "percentage")
    },
    {
      Header: "Reason for Deviation",
      accessor: "reason_deviation"
      // Cell: d => this.otherEdits(d, d.original.reason_deviation, "reason_deviation")
    },
    {
      Header: "Comments",
      accessor: "comment"
      // Cell: d => this.otherEdits(d, d.original.comment, "comment")
    },
    {
      Header: "Status",
      accessor: "status"
      // Cell: d => this.otherEdits(d, d.original.status, "status")
    }
  ];

  getDate = d => {
    let d1 = new Date(d);
    var date = d1.getDate();
    var month = d1.getMonth() + 1;
    var year = d1.getFullYear();
    return date + "/" + month + "/" + year;
  };

  date = d => {
    let i = d.index;

    var a = this.getDate(d.original.scheduled_start_date);
    let date1 = a.toString();

    var b = this.getDate(d.original.scheduled_end_date);
    let date2 = b.toString();

    var c = this.getDate(d.original.scheduled_end_date);
    let date3 = c.toString();

    return (
      <div>
        <div className=" form-group ">
          <div>Start Date :</div>
          <div>
            <input type="text" value={date1} />
          </div>
        </div>
        <div className="form-group">
          End Date :
          <div>
            <input type="text" value={date2} />
          </div>
        </div>
        <div className="form-group ">
          Actual End Date :
          <div>
            <input type="text" value={date3} />
          </div>
        </div>
      </div>
    );
  };

  render() {
    let borderstyle = {
      border: "0px"
    };
    const {
      data,
      user,
      name,
      workLvl,
      designationName,
      jobRoleName,
      tc,
      bc,
      derailers,
      yearList,
      idpTable,
      pdfIdp,
      SkillsData, SkillsData2, SkillsData1,
      ShortContentData, MidContentData, LongContentData, showdownload,
      groupcompany_details, logosrc
    } = this.state;
    // console.log(idpTable,pdfIdp)


    var userTechIndicators = [];
    if (user) {
      userTechIndicators = user[0].userTechIndicators;
    }
    //[{"themeid":90,"theme":"SAFETY, OCCUPATIONAL HEALTH & ENVIRONMENT","competencyid":301,"competencyname":"GRIEVANCE REDRESSAL","compDescription":"Ability to understand  Grievances and  Redressal l within the specified norms ","compImportant":"Employees and unions represent grievances relating to work practices, entitlements and they need to be addressed in a structured process to achieve mutual satisfaction.","textType":"Technical","indicators":[{"id":4299,"indicators":"Creates  fair environment for Grievance Redressal process.","textType":"Technical","cmplevel":"LEVEL 3"}]},{"themeid":89,"theme":"OFFSITES&SND","competencyid":301,"competencyname":"GRIEVANCE REDRESSAL","compDescription":"Ability to understand  Grievances and  Redressal l within the specified norms ","compImportant":"Employees and unions represent grievances relating to work practices, entitlements and they need to be addressed in a structured process to achieve mutual satisfaction.","textType":"Technical","indicators":[{"id":4299,"indicators":"Creates  fair environment for Grievance Redressal process.","textType":"Technical","cmplevel":"LEVEL 3"},{"id":4306,"indicators":" Establishes structured process for fair and just Grievance Handling. ","textType":"Technical","cmplevel":"LEVEL 4"}]},{"themeid":94,"theme":"MATERIALS","competencyid":235,"competencyname":"BULK MATERIAL HANDLING","compDescription":"Handling bulk solid material such that the losses in handling are minimized and cost due to handling is optimized within budgetary norm","compImportant":"Bulk raw material cost and availability are critical factors impacting  the business - cost has increased multiple times and availability in at source itself is depleting. Thus effective material handling of bulk solid material becomes essential","textType":"Technical","indicators":[{"id":1899,"indicators":"Assesses the losses and identifying the reasons / root causes","textType":"Technical","cmplevel":"LEVEL 4"},{"id":1898,"indicators":"Initiates countermeasures for minimizing the losses","textType":"Technical","cmplevel":"LEVEL 4"},{"id":1893,"indicators":"Alerts the concerned people on stock levels considering production planning and expected receipts;","textType":"Technical","cmplevel":"LEVEL 3"},{"id":1892,"indicators":"Trains others to prioritize material issue to optimize cost","textType":"Technical","cmplevel":"LEVEL 3"},{"id":1888,"indicators":"Arrives at differences in stock levels from book stock","textType":"Technical","cmplevel":"LEVEL 2"},{"id":1887,"indicators":"Measures and records the quantity of bulk material in open area with ease","textType":"Technical","cmplevel":"LEVEL 2"}]},{"themeid":88,"theme":"Finance","competencyid":294,"competencyname":"INSURANCE MANAGEMENT ","compDescription":"Ability to identify the possible risks  to various assets/ inventories from different events and natural calamities and providing safety coverage both in terms of monitory loss and statutory liability.","compImportant":"Large volumes of raw materials and stores items need to be procured from the international market (almost 90% of raw material) which involves large amounts of Logistics cost - both Overseas and Domestic - coupled with large amount of handling and clearing","textType":"Technical","indicators":[{"id":4125,"indicators":"Knows on Company policy on provision of Insurance coverage to  assets and stocks","textType":"Technical","cmplevel":"Level 1"},{"id":4129,"indicators":"dentifies  Risks and coverage Providers (Insurance Companies - marine/ fire/ theft/ cyclone/ earthquake/ commotion/ transit /third party) as per corporate policy.   ","textType":"Technical","cmplevel":"Level 2"},{"id":4157,"indicators":"Conversant with  different risks involved and their relevance to Company stocks/ assets   ","textType":"Technical","cmplevel":"Level 3"}]}]
    var content = [];
    if (userTechIndicators != null && userTechIndicators != undefined && userTechIndicators != "") {
      Object.keys(userTechIndicators).forEach(key => {
        var indicators = userTechIndicators[key].indicators
        var innerData = [];
        if (indicators != null && indicators != undefined && indicators != "") {
          Object.keys(indicators).forEach(key1 => {
            var data = indicators[key1].indicators;
            if (indicators != null && indicators != undefined && indicators != "") {
              innerData.push(
                <Text style={{ width: "70%", fontSize: 10 }} >
                  {data.toString()}
                </Text>
              )
            }
          })
        }
        content.push(
          <View style={{ flexGrow: 1 }}>
            <View style={{ flexGrow: 1, flexDirection: 'row', }}>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10 }} >
                <Text style={{ width: "20%", fontSize: 10, color: "red", fontFamily: 'CustomFont' }}>Theme</Text>
              </View>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10 }}>
                <Text style={{ width: "70%", fontSize: 10, fontFamily: 'ptsans' }}>{userTechIndicators[key].theme}</Text>
              </View>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10 }}>
                <Text style={{ width: "70%", fontSize: 10, fontFamily: 'ptsans' }} ></Text>
              </View>
            </View>

            <View style={{ flexGrow: 1, flexDirection: 'row', }}>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10 }}  >
                <Text style={{ width: "20%", fontSize: 10, color: "red", fontFamily: 'CustomFont' }} >Competency Name</Text>
              </View>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10 }}>
                <Text style={{ width: "70%", fontSize: 10, fontFamily: 'ptsans' }} >{userTechIndicators[key].competencyname}</Text>
              </View>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10 }}>
                <Text style={{ width: "70%", fontSize: 10, fontFamily: 'ptsans' }} ></Text>
              </View>
            </View>

            <View style={{ flexGrow: 1, flexDirection: 'row' }}>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10 }}>
                <Text style={{ width: "20%", fontSize: 10, color: "red", fontFamily: 'CustomFont' }} >Competency Definition</Text>
              </View>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10 }}>
                <Text style={{ width: "70%", fontSize: 10, fontFamily: 'ptsans' }}>{userTechIndicators[key].compDescription}</Text>
              </View>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10 }} >
                <Text style={{ width: "70%", fontSize: 10, fontFamily: 'ptsans' }} ></Text>
              </View>
            </View>

            <View style={{ flexGrow: 1, flexDirection: 'row' }}>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10 }} >
                <Text style={{ width: "20%", fontSize: 10, color: "red", fontFamily: 'CustomFont' }} >Why it s important</Text>
              </View>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10 }}>
                <Text style={{ width: "70%", fontSize: 10, margin: 10, fontFamily: 'ptsans' }}>{userTechIndicators[key].compImportant.toString()}</Text>
              </View>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10 }}>
                <Text style={{ width: "70%", fontSize: 10, fontFamily: 'ptsans' }}></Text>
              </View>
            </View>

            {/* <View >
                             <View >
                                <Text >Competency Definition</Text>
                            </View>
                            <View>
                                 <Text >{userTechIndicators[key].compDescription}</Text> 
                            </View>
                            <View>
                                <Text></Text>
                            </View>
                        </View> 
                        <View >
                            <View>
                                <Text >Why it s important</Text>
                            </View>
                            <View>
                                 <Text >{userTechIndicators[key].compImportant}</Text
                            </View>
                            <View  >
                                <Text  ></Text>
                            </View>
                        </View> */}
            <View style={{ flexGrow: 1, flexDirection: 'row' }}>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10 }}>
                <Text style={{ width: "20%", fontSize: 10, color: "red", fontFamily: 'CustomFont' }}>Indicators</Text>
              </View>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10, fontFamily: 'ptsans' }}>
                {
                  innerData
                }
              </View>
              <View style={{ position: "relative", flexGrow: 1, padding: 0, margin: 10 }}>
                <Text style={{ width: "70%", fontSize: 10, fontFamily: 'ptsans' }}></Text>
              </View>
            </View>
          </View>
        )
      })
    }
    if (!data) {
      return <PreLoader />;
    } else {
      let height = window.innerHeight;
      return (
        <section>
          <div className=" mt-100 container-fluid">
            <div className="col-12">
              <div className="content-border1 my-lg-5 my-3 px-lg-3">
                <div className="col-12 cons-report-head text-center">
                  <h3>Consolidated Report - {name}</h3>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 col-12 text-start">
                  {data && user && content
                    // && Object.keys(content).length > 0 
                    && user[0].userTechIndicators
                    && (
                      <PDFDownloadLink
                        style={{ color: "white" }}
                        document={
                          <ConsolidatePDF
                            data={data}
                            workLvl={workLvl}
                            designationName={designationName}
                            jobRoleName={jobRoleName}
                            user={user}
                            content={content}
                            userTechIndicators={user[0].userTechIndicators}
                            derailers={derailers}
                            idp={pdfIdp}
                            jobdescription={this.state.jobdescription}
                            logosrc={groupcompany_details}
                          />
                        }
                        fileName="Consolidate.pdf"
                      >
                        {({ blob, url, loading, error }) =>
                          loading ? "Loading document..." : "Download PDF"
                        }
                        <button type="button" className="submit-btn ">
                          Download PDF
                        </button>
                      </PDFDownloadLink>
                    )}
                </div>
                <div className="box-tools pull-right">
                  <button
                    className="btn btn-box-tool"
                    data-widget="collapse"
                    title="Collapse"
                  >
                    <i className="fa fa-minus"></i>
                  </button>
                </div>
                {data && (
                  <>
                    <div className="row justify-content-between align-items-start px-lg-3">
                      <div className="col-lg-4 col-xl-3 col-md-6 col-sm-12 col-12">
                        <div className="content-border1">
                          <div className="cons-user-image col-12 text-center my-3">
                            <img
                              src={
                                ACCESS_POINT +
                                `/getpro/getprofile?fileurl=` +
                                this.state.imageview
                              }
                              alt="No image"
                            />
                          </div>
                          <hr />
                          <div className="row justify-content-center align-items-center cons-user-details px-3">
                            <div className="col-2  text-start">
                              <p class="bi bi-person-circle"><span></span></p>
                            </div>
                            <div className="col-8 text-start">
                              <p>{data.name}</p>
                            </div>
                          </div>
                          <hr />
                          <div className="row justify-content-center align-items-center cons-user-details px-3">
                            <div className="col-2 text-start">
                              <p class="bi bi-envelope my-0"><span></span></p>
                            </div>
                            <div className="col-8 text-start">
                              <p>{data.email_id}</p>
                            </div>
                          </div>
                          <hr />
                          <div className="row justify-content-center align-items-center cons-user-details px-3">
                            <div className="col-2  text-start">
                              <p class="bi bi-phone my-0"><span></span></p>
                            </div>
                            <div className="col-8  text-start">
                              <p>{data.mobile_no}</p>
                            </div>
                          </div>
                          <hr />
                          <div className="row justify-content-center align-items-center cons-user-details px-3">
                            <div className="col-2  text-start">
                              <p class="bi bi-geo-alt my-0"><span></span></p>
                            </div>
                            <div className="col-8 text-start">
                              <p>{data.address}</p>
                            </div>
                          </div>
                          <hr />
                          <div className="row justify-content-center align-items-center cons-user-details px-3">
                            <div className="col-2  text-start">
                              <p class="bi bi-bar-chart my-0"><span></span></p>
                            </div>
                            <div className="col-8 text-start">
                              <p>{workLvl}</p>
                            </div>
                          </div>
                          <hr />
                          <div className="row justify-content-center align-items-center cons-user-details px-3">
                            <div className="col-2  text-start">
                              <p class="bi bi-calendar my-0"><span></span></p>
                            </div>
                            <div className="col-8 text-start">
                              <p>{data.age}<span>(Age)</span></p>
                            </div>
                          </div>
                          <hr />
                          <div className="row justify-content-center align-items-center cons-user-details px-3">
                            <div className="col-2  text-start">
                              <p class="bi bi-telephone my-0"><span></span></p>
                            </div>
                            <div className="col-8 text-start">
                              <p>{data.telphone}</p>
                            </div>
                          </div>
                          <hr />
                          <div className="row justify-content-center align-items-center cons-user-details px-3">
                            <div className="col-2  text-start">
                              <p class="bi bi-mortarboard my-0"><span></span></p>
                            </div>
                            <div className="col-8 text-start">
                              <p>{data.qualification}</p>
                            </div>
                          </div>
                          <hr />
                          <div className="row justify-content-center align-items-center cons-user-details px-3">
                            <div className="col-2  text-start">
                              <p class="bi bi-card-list my-0"><span></span></p>
                            </div>
                            <div className="col-8 text-start">
                              <p>{designationName}</p>
                            </div>
                          </div>
                          <hr />
                          <div className="row justify-content-center align-items-center cons-user-details px-3">
                            <div className="col-2  text-start">
                              <p class="bi bi-person-workspace my-0"><span></span></p>
                            </div>
                            <div className="col-8 text-start">
                              <p>{jobRoleName}</p>
                            </div>
                          </div>
                          <hr />
                        </div>
                      </div>
                      <div className="col-lg-8  col-xl-9 col-md-6 col-sm-12 col-12">
                        <div className="content-border1 px-2 px-lg-4">
                          <div className="cons-jd my-2">
                            <h3>Job Description</h3>
                            <hr />
                          </div>
                          <div className="cons-jd">
                            <p>
                              {this.state.jobdescription}
                            </p>
                          </div>
                        </div>
                        <div className="content-border1 px-2 px-lg-4 my-5">
                          <div className="cons-jd my-3">
                            <h3> TECHNICAL COMPETENCIES</h3>
                          </div>
                          <div className="">
                            {tc}
                          </div>
                          <hr />
                          <div className="text-center my-3 text">
                            <h3>Technial Derailers</h3>
                          </div>
                          <hr />
                          <div className="row justify-content-evenly align-items-center">
                            <div className="col-lg-3">
                              <div className="row justify-content-between align-items-center">
                                <h4 className="text">Derailers</h4>
                              </div>
                            </div>
                            <div className="col-lg-8 text">
                              {this.state.derail}
                            </div>
                          </div>
                        </div>
                        <div className="content-border1 px-2 px-lg-4 my-5">
                          <div className="cons-jd my-3">
                            <h3> BEHAVIOURAL COMPETENCIES</h3>
                          </div>
                          <hr />
                          <div className="">
                            {bc}
                          </div>
                          <div className="row justify-conten-evenly align-items-center my-3">
                            <div className="col-lg-1 d-none d-lg-none" />
                            <div className="col-lg-4 text ">
                              <h3>IDP</h3>
                            </div>
                            <div className="col-lg-6 text">
                              <SingleSelect
                                options={yearList}
                                handleChange={this.idp}
                                selectedService={this.state.idpYear}
                              />
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div className=" col-12 px-2 px-lg-5 my-5">
                      <div>

                        {""}
                        {/* {!(this.state.idpYear && idpTable.length === 0) && showdownload && */}
                        {/* {(this.state.idpYear) && showdownload &&
(
<PDFDownloadLink
style={{ color: "white" }}
document={
<IDPPDF
  data={pdfIdp}
  short ={  ShortContentData  }
 mid={MidContentData}
 long={LongContentData}
 section1={SkillsData}
 section2={SkillsData1}
 section3={SkillsData2}
 group={groupcompany_details}
                          
/>
}
fileName="Consolidate_IDP.pdf"
>
{({ blob, url, loading, error }) =>
loading ? "Loading document..." : "Download Pdf"
}
<button type="button" className="btn btn-success">
Download IDP PDF
</button>
</PDFDownloadLink>
)} */}
                        {this.state.idpYear && (
                          <ManageIDP1 report={true} idpYear={this.state.idpYear} />
                          // <Datatable data={idpTable} columnHeading={this.column} />
                        )}
                        {/*    {this.state.idpYear && idpTable.length === 0 && (
<span>No data exists for {this.state.idpYear.label}</span>
)} */}
                      </div>
                    </div>
                  </>
                )}
              </div>

            </div>
          </div>
        </section>
      );
    }
  }
}

Font.register({ family: 'CustomFont', src: customFont });
Font.register({ family: 'ptsans', src: ptsans });

export default ConsolidateReport;
